import React from 'react';
import './App.css';
import Menu from './components/menu';
import Routes from './routes';
import {BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
      <>
      <BrowserRouter>
         <nav className="navbar">
            <Menu />
         </nav>
         <main>
            <Routes />
         </main>
      </BrowserRouter>
      <Toaster position="bottom-right" />
      </>
      );
}

export default App;
